import script from "./rolePermission.vue?vue&type=script&setup=true&lang=js"
export * from "./rolePermission.vue?vue&type=script&setup=true&lang=js"

import "./rolePermission.vue?vue&type=style&index=0&id=e0f0b2c2&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0f0b2c2"]])

export default __exports__